// src/api.js
import axios from "axios";
import GetBaseUrl from "./functions/SetBaseUrl";

const BaseUrl = GetBaseUrl()[0];
var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

console.log(GetBaseUrl()[0]);
console.log(localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken"));

const api = axios.create({
  baseURL: BaseUrl,
  headers: {
    Authorization: `Bearer ${token}`,
    "content-type": "application/json",
  },
});

export default api;
